import apiClient from '../http/apiClient';
import publicApiClient from "../http/publicApiClient";

export default class BoxAPI {
    static getBoxes = (params) => {
        params.limit = 50;

        return apiClient.get('/box', {params});
    }

    static trace = (params) => publicApiClient.get(`/box/trace`, {params});

    static rebox = (hash, reboxData) => apiClient.put(`/box/${hash}/rebox`, reboxData);

    static freeze = (hash, customer) => apiClient.put(`/box/${hash}/freeze`, {customer});
    static thaw = (hash, customer) => apiClient.put(`/box/${hash}/thaw`, {customer});

    static burn = (hash, customer) => apiClient.put(`/box/${hash}/burn`, {customer});

    static transfer = (hash, customer, destination) => apiClient.put(`/box/${hash}/transfer`, {customer, destination});
}
